<template>
  <EditorPickLotteryQuickPickCard
    v-model:random="isRandom"
    class="pick-lottery-quick-pick-wager"
    :headline="$t('picklottery.quickpick.wager.title')"
  >
    <LcSlider
      v-bind="{ marker, max, min }"
      :aria-label="$t('picklottery.stake.slider.arialabel')"
      class="slider w-full"
      container-class="w-full"
      :format="toStakeMoney"
      :lazy="false"
      no-feedback
      :value="selectedWagerValue"
      @update:value="handleSetWager"
    />
  </EditorPickLotteryQuickPickCard>
</template>

<script lang="ts" setup>
import type { Config, PriceList } from '../@types/editor'

import { toStakeMoney } from '../utils/editorPlay'
import {
  getMaxWagerValue,
  getMinWagerValue,
  getPreparedWagers,
  getWagerMarker,
} from '../utils/editorWager'

type Props = {
  config: Config
  priceList: PriceList
}

const { config, priceList } = defineProps<Props>()

const stake = defineModel<Maybe<string>>('value', { required: true })

const preparedWagers = computed(() => getPreparedWagers(config, priceList))

const marker = computed(() => getWagerMarker(preparedWagers.value))

const max = computed(() => getMaxWagerValue(preparedWagers.value))

const min = computed(() => getMinWagerValue(preparedWagers.value))

const isRandom = computed({
  get: () => !stake.value,
  set: (random) => (stake.value = random ? null : (preparedWagers.value[0]?.id ?? null)),
})

const selectedWagerValue = computed(
  () => preparedWagers.value.find(({ id }) => id === stake.value)?.value ?? min.value,
)

const handleSetWager = (newValue?: number) => {
  const wager = preparedWagers.value.find(({ value }) => value === newValue)
  if (!wager) return
  stake.value = wager.id
}
</script>

<style lang="scss" scoped>
.pick-lottery-quick-pick-wager .slider :deep(.slider-base) {
  background-color: token('color/background/secondary/secondary');
}
</style>
